import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle";
import { DataSender } from '../loaders'

/*
* ManageDiscountCodesModal
*/

const DiscountCodeType = {
    MULTI:  'multi',
    SINGLE: 'single'
};

class ManageDiscountCodesModal {
    constructor(target, eventId) {
        if(!target || !target.length || !eventId) {
            window.activeModalInstance = null;
            return;
        }

        // properties
        this.target = target;

        this.currentSlide = 0;
        this.currentTab = null;
        this.eventId = eventId;
        this.locked = false;
        this.paidTicketsAvailable = false;

        // init
        this.loadModal();
    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

    slideTo(slide) {
        this.currentSlide = slide;

        this.slides.css('-webkit-transform', 'translateX(' + (slide * -800) + 'px)');
        this.slides.css('-moz-transform', 'translateX(' + (slide * -800) + 'px)');
        this.slides.css('transform', 'translateX(' + (slide * -800) + 'px)');
    }

    // MODAL:

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        this.target.show();

        new DataSender({
            data: {
                id: this.eventId
            },
            url: '/event/tickets/discount-codes/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);

                    that.currencyFormat = data.currency_format;
                    that.paidTicketsAvailable = data.paid_tickets;
                    that.texts = window.manageDiscountCodesModalTexts;

                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        this.header = this.target.find('.modal-header');
        this.headerBackButton = this.header.find('button.back');
        this.headerBackButton.bind('click', function() {
            if(that.locked) return;

            if(that.headerBackButton.hasClass('shown')) {
                that.closeCreate(false);
            }
        });

        this.headerTitle = this.header.find('.title');
        this.headerDetails = this.header.find('.details');

        this.headerCloseButton = this.header.find('button.close');
        this.headerCloseButton.bind('click', function() {
            if(that.locked) return;

            if(that.currentSlide > 0) {
                if(window.confirm(that.texts.progressConfirm)) {
                    that.closeModal();
                }
            }
            else {
                that.closeModal();
            }
        });

        this.slides = this.target.find('.modal-body .wrapper');
        this.manageSlide = this.slides.find('.manage');
        this.createSlide = this.slides.find('.create');

        this.initManageSlide();
    }

    closeModal() {
        this.target.hide();
        // $('body').removeClass('modal-open');
        // $('.modal-backdrop,.modal').remove();

        window.activeModalInstance = null;
    }

    // MANAGE

    initManageSlide() {
        var that = this;

        this.manageCreateTab = this.manageSlide.find('#create');
        this.manageMultiTab = this.manageSlide.find('#multi');
        this.manageSingleTab = this.manageSlide.find('#single');

        // tabs
        this.manageSlideTabs = this.manageSlide.find('.tabs a');
        this.manageSlideTabs.each(function(index) {
            var tab = $(this);

            tab.bind('click', function() {
                if(that.locked) return;

                that.manageSlideTabs.removeClass('active');
                tab.removeClass('new').addClass('active');

                if(index == 0) that.openCreateTab();
                if(index == 1) that.openMultiTab();
                if(index == 2) that.openSingleTab();

                return false;
            });
        });

        this.manageSlideTabs.eq(0).click();
    }

    openCreateTab() {
        if (this.locked) return;

        var that = this;
        this.currentTab = 'create';

        this.manageCreateTab.removeClass('hidden');
        this.manageMultiTab.addClass('hidden');
        this.manageSingleTab.addClass('hidden');

        if(!this.createTabInited) {
            this.manageCreateTab.find('a').bind('click', function() {
                that.loadCreate($(this).data('type'));
                return false;
            });

            this.createTabInited = true;
        }
    }

    openMultiTab() {
        if (this.locked) return;

        var that = this;
        this.currentTab = DiscountCodeType.MULTI;

        this.manageCreateTab.addClass('hidden');
        this.manageMultiTab.removeClass('hidden');
        this.manageSingleTab.addClass('hidden');

        if(!this.multiTabInited) {
            this.loadTab(DiscountCodeType.MULTI);
            this.multiTabInited = true;
        }
    }

    openSingleTab() {
        if (this.locked) return;

        var that = this;
        this.currentTab = DiscountCodeType.SINGLE;

        this.manageCreateTab.addClass('hidden');
        this.manageMultiTab.addClass('hidden');
        this.manageSingleTab.removeClass('hidden');

        if(!this.singleTabInited) {
            this.loadTab(DiscountCodeType.SINGLE);
            this.singleTabInited = true;
        }
    }

    loadTab(type) {
        if (this.locked) return;
        this.lock();

        var that = this;

        var tab = (type == DiscountCodeType.MULTI) ? this.manageMultiTab : this.manageSingleTab;
        tab.html('<div class="activity-indicator gray"></div>');

        new DataSender({
            data: {
                id: this.eventId,
                type: type
            },
            url: '/event/tickets/discount-codes/load/',

            success: function(data) {
                tab.html(data.html);
                that.initTab(tab);
            },

            error: function() {
                that.unlock();
            }
        });

    }

    reloadTab(type) {
        this.loadTab(type);
    }

    initTab(tab) {
        var that = this;

        if(tab.find('.empty').length) {
            if(!this.paidTicketsAvailable) {
                tab.find('a.btn-primary').addClass('disabled');
            }

            tab.find('a.btn-primary').bind('click', function() {
                that.loadCreate($(this).data('type'));
                return false;;
            });
        }
        else {
            var header = tab.find('.header');
            var list = tab.find('ul');
            var totalCodes = list.find('li').length - 1;

            header.find('input').bind('input', function() {
                that.filterCodesList(list, $.trim($(this).val()));
            });

            list.find('li').each(function() {
                var li = $(this);
                var code = li.find('.code');
                var details = li.find('.details');

                var tooltipTriggerList = [].slice.call(li.find('*[data-bs-toggle="tooltip"]'));
                var tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => tooltipTriggerEl.offsetWidth >= tooltipTriggerEl.scrollWidth && $(tooltipTriggerEl).is("a") ? null : new Tooltip(tooltipTriggerEl));

                code.find('a.name').bind('click', function() {
                    if(li.hasClass('opened')) {
                        li.removeClass('opened');
                        details.animate({ height: 0 }, 250);
                    }
                    else {
                        li.addClass('opened');
                        details.animate({ height: details.data('height') }, 250);
                    }

                    return false;
                });

                code.find('label.new-switch input').bind('change', function() {
                    var checkbox = $(this);
                    var active = checkbox.is(':checked') ? true : false;

                    if(active) {
                        checkbox.parent().highlight('green', { hideEvent: 'mouseleave', offset: [-10, 0], placement: 'left', text: that.texts.codeEnabled });
                    }
                    else {
                        checkbox.parent().highlight('yellow', { hideEvent: 'mouseleave', offset: [-10, 0], placement: 'left', text: that.texts.codeDisabled });
                    }

                    that.toggleDiscountCode(li.data('code-id'), active);
                });

                details.height('auto').data('height', details.outerHeight()).height(0);

                details.find('.actions .delete').bind('click', function() {
                    if(that.locked) return false;

                    if(!$(this).hasClass('disabled')) {
                        if(window.confirm(that.texts.deleteConfirm)) {
                            that.lock();

                            that.deleteDiscountCode(li.data('code-id'), function(status) {
                                if(status) {
                                    totalCodes--;

                                    if(!totalCodes) {
                                        that.unlock();

                                        if(list.parent().prop('id') == DiscountCodeType.MULTI) {
                                            that.reloadTab(DiscountCodeType.MULTI);
                                        }
                                        else {
                                            that.reloadTab(DiscountCodeType.SINGLE);
                                        }
                                    }
                                    else {
                                        li.slideToggle(250);

                                        window.setTimeout(function() {
                                            li.remove();

                                            header.find('h3').html((totalCodes == 1 ? that.texts.singleCodeCreated : that.texts.multipleCodesCreated).replace(/%d/, totalCodes));
                                            header.find('input').trigger('input');

                                            that.unlock();
                                        }, 300);
                                    }
                                }
                                else {
                                    that.unlock();
                                }
                            });
                        }
                    }

                    return false;
                });
            });
        }

        this.unlock();
    }

    filterCodesList(list, searchValue) {
        var searchValueLength = searchValue.length;
        searchValue = searchValue.toLowerCase();

        if(searchValueLength > 0) {
            var item = null,
                code = null,
                match = null,
                matchedCount = 0;

            list.find('li.code').addClass('hide').each(function() {
                item = $(this);
                code = item.find('.code');
                match = false;

                code.find('.name').html(item.data('code'));
                code.find('.discount .value').html(item.data('discount'));

                if(searchValue == item.data('code').toLowerCase().substr(0, searchValueLength)) {
                    match = true;
                    code.find('.name').html('<i>' + item.data('code').substr(0, searchValueLength) + '</i>' + item.data('code').substr(searchValueLength));
                }

                if(searchValue == item.data('discount').toLowerCase().substr(0, searchValueLength)) {
                    match = true;
                    code.find('.discount .value').html('<i>' + item.data('discount').substr(0, searchValueLength) + '</i>' + item.data('discount').substr(searchValueLength));
                }

                if(match) {
                    item.removeClass('hide');
                    matchedCount++;
                }
            });

            if(!matchedCount) {
                list.find('li.no-matches').removeClass('hide');
            }
            else {
                list.find('li.no-matches').addClass('hide');
            }
        }
        else {
            var item = null,
                code = null;

            list.find('li.no-matches').addClass('hide');

            list.find('li.code').removeClass('hide').each(function() {
                item = $(this);
                code = item.find('.code');
                code.find('.name').html(item.data('code'));
                code.find('.discount .value').html(item.data('discount'));
            });
        }
    }

    toggleDiscountCode(codeId, active) {
        new DataSender({
            data: {
                id: codeId,
                active: active ? 1 : 0
            },
            url: '/event/tickets/discount-codes/toggle-code/'
        });
    }

    deleteDiscountCode(codeId, callback) {
        new DataSender({
            data: {
                id: codeId
            },
            url: '/event/tickets/discount-codes/delete-code/',

            success: function(data) {
                if(data.status) {
                    if(callback) {
                        callback(true);
                    }
                }
            },

            error: function() {
                if(callback) {
                    callback(false);
                }
            }
        });
    }

    updateCodes() {
        if(this.currentTab == 'create') {
            var tab;

            if(this.codeType == DiscountCodeType.MULTI) {
                tab = this.manageSlideTabs.eq(1);
                this.multiTabInited = false;
            }

            if(this.codeType == DiscountCodeType.SINGLE) {
                tab = this.manageSlideTabs.eq(2);
                this.singleTabInited = false;
            }

            if(tab) {
                window.setTimeout(function() {
                    tab.addClass('new');
                }, 250);
            }
        }
        else if(this.currentTab == DiscountCodeType.MULTI) {
            this.reloadTab(DiscountCodeType.MULTI);
        }
        else if(this.currentTab == DiscountCodeType.SINGLE) {
            this.reloadTab(DiscountCodeType.SINGLE);
        }
    }

    // CREATE:

    loadCreate(type) {
        if(this.locked || this.currentSlide > 0 || !this.paidTicketsAvailable) return;
        this.lock();

        var that = this;
        this.codeType = type;

        this.createSlide.html('<div class="activity-indicator gray"></div>');
        this.headerBackButton.addClass('shown');
        this.header.addClass('single-title');
        this.headerTitle.text((type == DiscountCodeType.MULTI) ? this.texts.createMultiUseCodes : this.texts.createSingleUseCodes);
        this.slideTo(1);

        new DataSender({
            data: {
                id: this.eventId,
                type: type
            },
            url: '/event/tickets/discount-codes/create/',

            success: function(data) {
                that.createSlide.html(data.html);
                that.initCreate();
            },

            error: function(e) {
                that.unlock();

                window.setTimeout(function() {
                    that.closeCreate();
                }, 500);
            }
        });
    }

    initCreate() {
        var that = this;

        var form = this.createSlide.find('form');
        var codesFieldset = form.find('.codes fieldset');
        var numberOfCodesInput = form.find('.codes input');
        var discountInput = form.find('.discount input');
        var discountSelect = form.find('.discount select');
        var categoriesItems = form.find('.categories label');
        var categoriesDetails = form.find('.categories div.details div:not(.free)');
        var periodStartDate = form.find('.period fieldset.start input.date');
        var periodStartTime = form.find('.period fieldset.start input.time');
        var periodEndDate = form.find('.period fieldset.end input.date');
        var periodEndTime = form.find('.period fieldset.end input.time');
        var usesRadios = form.find('.uses input[type="radio"]');
        var usesInputs = form.find('.uses input[type="text"]');
        var usesDetails = form.find('.uses div.details');

        // CODES:
        if(this.codeType == DiscountCodeType.MULTI) {
            var MAXIMUM_CODES = 20;

            var codesCount = 1;
            var addButton = codesFieldset.find('a.add');

            addButton.bind('click', function() {8
                if(codesCount < MAXIMUM_CODES) {
                    addCode();
                    codesCount++;

                    if(codesCount == MAXIMUM_CODES) {
                        addButton.addClass('disabled');
                    }
                }

                return false;
            });

            var addCode = function() {
                var divider = $('<div class="divider"></div>').appendTo(codesFieldset);
                var input = $('<input autocomplete="off" autocorrect="off" maxlength="16" name="codes[]" placeholder="' + that.texts.multiCodeDefaultPlaceholder + '" type="text" />').appendTo(codesFieldset);
                var button = $('<a class="remove" href="#"></a>').appendTo(codesFieldset);

                button.bind('click', function() {
                    removeCode(divider, input, button);
                    addButton.removeClass('disabled');
                    codesCount--;

                    return false;
                });

                input.focus();
            };

            var removeCode = function(divider, input, button) {
                divider.remove();
                input.removeHighlight().remove();
                button.remove();
            };

            window.setTimeout(function() {
                codesFieldset.find('input').focus();
            }, 400);
        }
        else {
            numberOfCodesInput.integerInput();
            numberOfCodesInput.bind('blur', function() {
                if(numberOfCodesInput.val()) {
                    if(!parseInt(numberOfCodesInput.val())) {
                        numberOfCodesInput.val('');
                    }
                    else {
                        numberOfCodesInput.val(parseInt(Math.max(0, Math.min(parseInt(numberOfCodesInput.val()), 9999))));
                    }
                }
            });

            form.find('.codes .details strong').text(Math.random().toString(36).substr(2, 8));

            window.setTimeout(function() {
                numberOfCodesInput.focus();
            }, 400);
        }

        // DISCOUNT:
        var MAXIMUM_CURRENCY = 999.99;
        var MAXIMUM_PERCENT = 100.00;

        var recalculateDiscounts = function() {
            var type = discountSelect.val();
            var max = (type == 'percent') ? MAXIMUM_PERCENT : MAXIMUM_CURRENCY;
            var amount = parseFloat(discountInput.val());

            if(!amount) {
                amount = 0;
            }
            else {
                amount = parseFloat(Math.max(0.01, Math.min(amount, max))).toFixed(2);
            }

            if(amount === 0) {
                categoriesDetails.find('span').html('');
                categoriesDetails.find('strong').html('');
            }
            else {
                categoriesItems.each(function() {
                    var input = $(this).find('input');
                    var details = categoriesDetails.filter('#' + $(this).prop('id'));

                    if(!input.is(':checked')) {
                        details.find('span').html('');
                        details.find('strong').html('');
                    }
                    else {
                        var oldPrice = parseFloat(details.data('price'));
                        var newPrice = 0;

                        if(type == 'percent') {
                            newPrice = (oldPrice - oldPrice * amount / 100);

                            details.find('span').html(' – ' + amount + '% = ');
                            details.find('strong').html(that.currencyFormat.replace(/%s/, newPrice.toFixed(2)));
                        }
                        else {
                            newPrice = Math.max(0, (oldPrice - amount));

                            details.find('span').html(' – ' + that.currencyFormat.replace(/%s/, amount) + ' = ');
                            details.find('strong').html(that.currencyFormat.replace(/%s/, newPrice.toFixed(2)));
                        }
                    }
                });
            }
        };

        discountInput.floatInput();
        discountInput.bind('blur', function() {
            if(discountInput.val()) {
                if(!parseFloat(discountInput.val())) {
                    discountInput.val('');
                    recalculateDiscounts();
                }
                else {
                    var max = (discountSelect.val() == 'percent') ? MAXIMUM_PERCENT : MAXIMUM_CURRENCY;
                    discountInput.val(parseFloat(Math.max(0.01, Math.min(parseFloat(discountInput.val()), max))).toFixed(2));
                }
            }
        });

        discountInput.bind('input', function() {
            recalculateDiscounts();
        });

        discountSelect.bind('change', function() {
            discountInput.trigger('blur');
            recalculateDiscounts();
        });

        // CATEGORIES:
        categoriesItems.find('input').bind('change', function() {
            var details = categoriesDetails.filter('#' + $(this).parent().prop('id'));
            ($(this).is(':checked')) ? details.removeClass('disabled') : details.addClass('disabled');

            recalculateDiscounts();
        });

        // PERIOD:
        periodStartDate.datepicker({
            format: window.evedo.dateFormat,
            weekStart: 1
        })
        .on('changeDate', function(e) {
            periodStartDate.datepicker('hide');

            if(periodStartTime.val() == '') {
                periodStartTime.val('00:00');
            }
        });

        periodStartTime.timepicker({ defaultValue: 'value', showMeridian: false });

        periodEndDate.datepicker({
            format: window.evedo.dateFormat,
            weekStart: 1
        })
        .on('changeDate', function(e) {
            periodEndDate.datepicker('hide');

            if(periodEndTime.val() == '') {
                periodEndTime.val('23:59');
            }
        });

        periodEndTime.timepicker({ defaultValue: 'value', showMeridian: false });

        // USES:
        if(this.codeType == DiscountCodeType.MULTI) {
            var updateDetails = function() {
                var number = usesInputs.filter(':not(:disabled)').val();
                var type = usesRadios.filter(':checked').val();

                if(type == '1') {
                    usesDetails.text(that.texts.uses.multiCodes[type]);
                }
                else {
                    if(number == '') {
                        usesDetails.text('');
                    }
                    else {
                        usesDetails.text(that.texts.uses.multiCodes[type][(number == 1) ? 0 : 1]);
                        usesDetails.text(usesDetails.text().replace(/%d/, number));
                    }
                }
            };

            usesRadios.bind('change', function() {
                usesInputs.prop('disabled', 'disabled');

                if($(this).is(':checked')) {
                    $(this).parent().find('input[type="text"]').removeAttr('disabled').select();
                }

                updateDetails();
            });

            usesInputs.integerInput();
            usesInputs.bind('blur', function() {
                if(!parseFloat($(this).val())) {
                    $(this).val(1);
                }
                else {
                    $(this).val(parseFloat(Math.max(1, Math.min(parseFloat($(this).val()), 999))));
                }

                updateDetails();
            });
            usesInputs.bind('input', updateDetails);

            updateDetails();
        }
        else {
            var updateDetails = function() {
                usesDetails.text(that.texts.uses.singleCodes[usesRadios.filter(':checked').val()]);
            };

            usesRadios.bind('change', updateDetails);
            updateDetails();
        }

        // CANCEL BUTTON:
        form.find('.actions button[type="button"]').bind('click', function() {
            if(!that.locked) {
                that.closeCreate(false);
            }

            return false;
        });

        // SUBMIT:
        form.bind('submit', function() {
            var data = that.serializeData(form);

            if(data) {
                that.saveDiscountCodes(data);
            }

            return false;
        });

        that.unlock();
    }

    serializeData(form) {
        var that = this;
        var data = {
            code_type: this.codeType,
            codes: [],
            discount: null,
            discount_type: null,
            categories: [],
            start_at: null,
            start_time: null,
            end_at: null,
            end_time: null,
            uses_type: null,
            uses_number: null
        };
        var input = null;

        // CODES:
        if(this.codeType == DiscountCodeType.MULTI) {
            var codes = form.find('.codes input[name="codes[]"]');

            for(var i = 0; i < codes.length; i++) {
                input = codes.eq(i);
                var value = $.trim(input.val());

                if(value) {
                    data.codes.push(value);
                }
                else {
                    input.highlight('red', { hideEvent: 'input', offset: [31,0], placement: 'right', text: that.texts.errors.codes.enterCode });
                    input.focus();
                    return null;
                }
            }
        }
        else {
            input = form.find('.codes input[name="number-of-codes"]');
            data.codes = input.val();

            if(!data.codes) {
                input.highlight('red', { hideEvent: 'input', placement: 'right', text: that.texts.errors.codes.enterNumber });
                input.focus();
                return null;
            }
        }

        // DISCOUNT:
        input = form.find('.discount input');

        data.discount = input.val();
        data.discount_type = form.find('.discount select').val();

        if(!data.discount) {
            input.highlight('red', { hideEvent: 'input', offset: [67,0], placement: 'right', text: that.texts.errors.discount.enterAmount });
            input.focus();
            return null;
        }

        // CATEGORIES:
        var categories = form.find('.categories input[name="categories[]"]');

        for(var i = 0; i < categories.length; i++) {
            input = categories.eq(i);

            if(!input.is(':disabled') && input.is(':checked')) {
                data.categories.push(input.val());
            }
        }

        if(!data.categories.length) {
            categories.parent().parent().highlight('red', { hideEvent: 'click', offset: [0,0], placement: 'right', text: that.texts.errors.categories.oneCategory });
            form.parent().scrollTop(form.find('.categories').offset().top);
            return null;
        }

        // PERIOD:
        data.start_at = form.find('.period fieldset.start input.date').val();
        data.start_time = form.find('.period fieldset.start input.time').val();
        data.end_at = form.find('.period fieldset.end input.date').val();
        data.end_time = form.find('.period fieldset.end input.time').val();

        // USES:
        data.uses_type = form.find('.uses input[type="radio"]:checked').val();

        if(this.codeType == DiscountCodeType.MULTI) {
            if (data.uses_type != '1') {
                data.uses_number = parseInt(form.find('.uses input[type="text"]:not(:disabled)').val());
            }
        }

        return data;
    }

    saveDiscountCodes(data) {
        if(this.locked) return;
        this.lock();

        var that = this;
        var form = this.createSlide.find('form');
        var actions = form.find('.actions');

        form.parent().scrollTop(form.parent().prop('scrollHeight'));
        actions.addClass('loader');

        new DataSender({
            data: {
                id: this.eventId,
                data: data
            },
            url: '/event/tickets/discount-codes/save/',

            success: function(data) {
                if(data.status) {
                    console.log(JSON.stringify(data.debug, null, 4));
                    actions.addClass('success');

                    window.setTimeout(function() {
                        that.unlock();
                        that.closeCreate(true);
                    }, 500);
                }
                else {

                    actions.removeClass('loader success');
                    that.unlock();
                }
            },

            error: function() {
                that.unlock();
            }
        });
    }

    closeCreate(update) {
        if(this.locked || this.currentSlide < 1) return;
        this.lock();

        var that = this;

        this.headerBackButton.removeClass('shown');
        this.header.removeClass('single-title');
        this.headerTitle.text(this.texts.manageDiscountCodes);
        this.slideTo(0);

        window.setTimeout(function() {
            that.createSlide.html('');
            that.unlock();

            if(update) {
                that.updateCodes();
            }

            that.codeType = null;
        }, 500);
    }
}

export { ManageDiscountCodesModal }
